import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';

import { _post } from '../../../utils/network';

import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb.component';
import FormField from "../../../components/Form/FormField/FormField.component";
import LoadingButton from '../../../components/LoadingButton/LoadingButton.component';
import ListTable from '../../../components/List/ListTable/ListTable.component';
import Pagination from '../../../components/List/Pagination/Pagination.component';

const ConsultantsList = () => {
	const { t } = useTranslation();
	const breadcrumbItems = [
		{ title: t('dashboard'), link: '/dashboard' },
		{ title: t('consultants'), link: '/consultants-list' },
		{ title: t('list') }
	];

	const [consultants, setConsultants] = useState([]);
	let consultantsListData = {
		head: [t('fullname'), t('rate'), t('status'), t('operation')],
		body: consultants.map(consultant => [
			consultant.consultant_name,
			consultant.rate || 5,
			<span className={"badge rounded-pill p-2 badge-subtle-" + (consultant.is_active ? 'success' : 'secondary')}>
				{consultant.is_active ? t('active') : t('deactive')}
			</span>,
			<Link className='btn btn-secondary btn-sm p-1' to={`/consultants-edit/${consultant.consultant_id}`}>
				<i className="fa fa-edit"></i> {t('edit')}
			</Link>
		]),
		directions: ['rtl', 'ltr', '', 'ltr']
	};

	const [pageNumber, setPageNumber] = useState(1);
	const [pageCounter] = useState(10);
	const [totalCount, setTotalCount] = useState(0);
	const [pagesCount, setPagesCount] = useState(0);
	const [searchConsultantTitle, setSearchConsultantTitle] = useState(null);
	const [searchButtonIsLoading, setSearchButtonIsLoading] = useState(false);
	const [searchCounter, setSearchCounter] = useState(0);
	const getConsultants = async () => {
		let body = {
			consultant_name: searchConsultantTitle,
			page: pageNumber,
			count: pageCounter
		};
		setSearchButtonIsLoading(true);
		let response = await _post('/consultants/admin/getAll', body);
		setSearchButtonIsLoading(false);
		switch(response.code){
			case 200:
				setTotalCount(response.data.all_consultants);
				setConsultants(response.data.consultants);
				break;
			default:
				toast.error(response[t('api_message')]);
		}
	};
	
	const filterConsultants = event => {
		event.preventDefault();
		if(searchButtonIsLoading)
			return 0;
		let title = event.target.searchConsultantTitle.value.trim() || null;
		setSearchConsultantTitle(title);
		if(pageNumber === 1)
			setSearchCounter(searchCounter + 1);
		else
			setPageNumber(1);
	};
	
	useEffect(() => {
		setPagesCount(Math.ceil(totalCount / pageCounter));
	}, [totalCount]);
	
	useEffect(() => {
		setSearchCounter(searchCounter + 1);
	}, [pageNumber]);

	useEffect(() => {
		getConsultants();
	}, [searchCounter]);
	
	return (
		<>
			<Breadcrumb items={breadcrumbItems} />
			<div className="card mb-3">
				<div className="card-header">
					<h5 className="mb-0">{t('search_for')} {t('consultants')}</h5>
				</div>
				<div className="card-body bg-light">
					<form onSubmit={filterConsultants}>
						<div className="row gx-2">
							<FormField fieldKey="searchConsultantTitle" title={t('title')} value={searchConsultantTitle} isSearch={true} />
						</div>
						<div>
							<LoadingButton className="btn btn-primary d-inline-block mt-3 me-2" type="submit" name="create" isLoading={searchButtonIsLoading}>
								<i className="fa fa-search"></i> {t('search')}
							</LoadingButton>
						</div>
					</form>
				</div>
			</div>
			<ListTable title={t('consultants')} pageNumber={pageNumber} pageCounter={pageCounter} totalCount={totalCount} data={consultantsListData} />
			<Pagination pagesCount={pagesCount} action={setPageNumber} />
		</>
	);
};

export default ConsultantsList;
